import { keepPreviousData } from '@tanstack/react-query';
import { DAYS_TO_MS, SECONDS_TO_MS } from '@utils/constants';
import { getComponentEntriesRequest } from './request.get-component-entries.js';

const getComponentEntriesKey = (user, timespan) => ["user-area/get-component-entries", user?.id, timespan];
const getComponentEntriesQuery = (user, timespan) => {
  return {
    staleTime: 15 * SECONDS_TO_MS,
    gcTime: 7 * DAYS_TO_MS,
    meta: {
      persist: true,
      revalidateOnRefresh: true
    },
    queryKey: getComponentEntriesKey(user, timespan),
    queryFn: () => getComponentEntriesRequest(user, timespan),
    placeholderData: keepPreviousData
  };
};

export { getComponentEntriesKey, getComponentEntriesQuery };
//# sourceMappingURL=query.get-component-entries.js.map
